import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import TextInput from '../../../../Shared/TextInput/TextInput';
import PopUp from '../../../../Shared/Popup/PopUp';
import Config from '../../../../../Config';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import { createSaleAsync } from '../../AddonsBlockAsyncThunk';
import { reportDWH, updateService, setNewPrimaryEmail } from '../../AddonsBlockSlice';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const ServicePage = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [serviceData, setServiceData] = useState({
        isConfirmTerms: { value: false, error: '' },
        email: { value: props.primaryEmail, error: '' }
    });
    const [isEditEmail, setIsEditEmail] = useState(false);

    useEffect(() => {
        props.reportDWH({ actionType: 'Internet Service Page', status: 'Ongoing', messageText: 'Internet Service Page Displayed' });
        if (props.primaryEmail) {
            gtag4({ event: `Addon_${props.flowType}_Step2_AddonInfoPageMail`, step: '2', action: 'AddonInfoPageMail', funnel_name: `Addon_${props.flowType}` });
        }
        else {
            gtag4({ event: `Addon_${props.flowType}_Step2_AddonInfoPageNoMail`, step: '2', action: 'AddonInfoPageNoMail', funnel_name: `Addon_${props.flowType}` });
        }
    }, []);

    return (
        <div className='service-page'>

            <div className='service-name'> {props.addon.cmsData?.productNameSelfCare} </div>

            <div className='service-icon'>
                <Image src={Config.epiBaseUrl + props.addon.cmsData?.imageAddonSelfCare} alt={props.addon.cmsData?.productNameSelfCare} />
            </div>

            {
                props.addon.cmsData?.titleAddonSelfCare &&
                <div className='service-title' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.titleAddonSelfCare }}></div>
            }

            {
                props.addon.cmsData?.descriptionProductSelfCare &&
                <div className='description' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.descriptionProductSelfCare }}></div>
            }

            {
                props.addon.cmsData?.textWithIconList.length > 0 &&
                <div className='properties-wrapper'>
                    <ul className='properties'>
                        {
                            props.addon.cmsData?.textWithIconList.map((item, index) => {
                                return (
                                    <li key={index}>
                                        {item.icon && <span className='property-icon' style={{ backgroundImage: `url(${Config.epiBaseUrl + item.icon})` }}></span>}
                                        <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }

            {
                props.addon.cmsData?.textLinkSelfCare &&
                <>
                    <div className='link-wrapper'>
                        <a href='#' onClick={(e) => handleOpenPopup(e)}>{props.addon.cmsData?.textLinkSelfCare}</a>
                    </div>

                    <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'חזרה', onBtnClick: handleClosePopup }}>
                        <div className='popup-image'><Image src={Config.epiBaseUrl + props.addon.cmsData?.imagePopUpSelfCare} /></div>
                        <div className='popup-title' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.titlePopUpSelfCare }}></div>
                        <div className='custom-scrollbar'>
                            <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.textPopUpSelfCare }}></div>
                        </div>
                        {
                            props.addon.cmsData?.textLinkPopUpSelfCare &&
                            <div className='popup-link'>
                                <a href='#' onClick={(e) => { e.preventDefault(); buildUrlAndOpenWindow(props.addon.cmsData?.linkRegulationsSelfCare) }}>{props.addon.cmsData?.textLinkPopUpSelfCare}</a>
                            </div>
                        }
                    </PopUp>
                </>
            }

            <div className='price-wrapper'>
                {
                    props.addon.cmsData?.marketingText && (displayPrice(props.addon.originalPrice) > displayPrice(props.addon.price) || props.addon.priceItemList.length > 0) &&
                    < div className='price-title'> {props.addon.cmsData?.marketingText} </div>
                }

                {
                    props.addon.priceItemList.length > 0 ? (
                        <div className='price-details'>
                            {
                                props.addon.priceItemList.map((item, index) => {
                                    return (
                                        <div className='price-row' key={index}>
                                            <div className='price-text'> {getPriceText(item)} </div>
                                            <div className='price'>
                                                {
                                                    displayPrice(item.price) == 0 ? (
                                                        <span className='no-price'> ללא עלות </span>
                                                    ) : (
                                                        <> {item.price} <span className='nis'>₪</span> </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    ) : (
                        <div className='price-details'>
                            <div className='price-row'>
                                <div className='price-text'> חיוב לחודש </div>
                                <div className='price'>
                                    {
                                        displayPrice(props.addon?.price) == 0 ? (
                                            <span className='no-price'> ללא עלות </span>
                                        ) : (
                                            <> {props.addon?.price} <span className='nis'>₪</span> </>
                                        )
                                    }
                                    {
                                        displayPrice(props.addon?.originalPrice) > displayPrice(props.addon?.price) &&
                                        <div className='original-price'>
                                            במקום <div className='price'> {displayPrice(props.addon?.originalPrice)} <span>₪</span> </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    )

                }

            </div>

            {
                props.isDisplayPrimaryEmail &&
                <div className='email-wrapper'>
                    {
                        isEditEmail || !props.primaryEmail ? (
                            <div className='email-form-wrapper'>
                                <div className='email-title'> לאיזה מייל לשלוח את הנחיות ההתקנה? </div>
                                <div className='email-form'>
                                    <div className='form-title'> {Config.receivingAdTitle} </div>
                                    <div className='email-field'>
                                        <TextInput placeholder='מייל' error={serviceData.email.error} required="required" onChange={(e) => { handleEmailChange(e.target.value) }} value={serviceData.email.value} />
                                    </div>
                                    <div className='bottom-text'> {Config.primaryEmailText} <a href='#' onClick={(e) => { e.preventDefault(); buildUrlAndOpenWindow(Config.primaryEmailMoreInfoUrl) }}>{Config.primaryEmailMoreInfoText}</a> </div>
                                </div>
                            </div>
                        ) : (
                            <div className='email-text-wrapper'>
                                פרטי התקנת השירות יישלחו לכתובת מייל ראשית
                                לדיוור ומידע <span>{props.primaryEmail}</span>
                                <div> <a href='#' onClick={(e) => handleSetIsEditEmail(e, true)}>עדכון מייל</a> </div>
                            </div>
                        )
                    }
                </div>
            }

            {
                props.isDisplayTermsCheckbox &&
                <div className='terms-wrapper'>
                    <CheckBox
                        checked={serviceData.isConfirmTerms.value}
                        label={< > אני מאשר/ת את <a href='#' onClick={() => buildUrlAndOpenWindow(props.termsLink)}>תנאי השירות</a> </>}
                        id='isConfirmTerms'
                        error={serviceData.isConfirmTerms.error}
                        onCheck={() => onCheck('isConfirmTerms')}
                        onUncheck={() => onUncheck('isConfirmTerms')} />
                </div>
            }

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='אישור והזמנה'
                    onclick={handleOnContinue}
                    formid='service-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}
                />
            </div>

        </div >
    );


    function onCheck(checkboxName) {
        serviceData[checkboxName].value = true;
        serviceData[checkboxName].error = '';
        setServiceData({ ...serviceData });
    }


    function onUncheck(checkboxName) {
        serviceData[checkboxName].value = false;
        serviceData[checkboxName].error = 'נא לאשר את תנאי החבילה';
        setServiceData({ ...serviceData });
    }

    function handleSetIsEditEmail(e, isEdit) {
        e.preventDefault();
        setIsEditEmail(isEdit);
    }

    function handleEmailChange(value) {
        serviceData['email'].value = value;

        if (!isValidEMail(value)) {
            serviceData['email'].error = 'נא להזין ערך תקין';
        }
        else {
            serviceData['email'].error = '';
        }

        setServiceData({ ...serviceData });
    }


    function isValidEMail(email) {
        return /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/.test(email);
    }


    function handleOpenPopup(e) {
        e.preventDefault();
        setIsDisplayPopup(true);
    }


    function handleClosePopup() {
        setIsDisplayPopup(false);
    }


    function handleOnContinue() {
        const isValid = validatePage();
        if (!isValid) { return; }

        props.reportDWH({ actionType: 'Internet Service Page', status: 'Ongoing', messageText: 'Internet Service Page Clicked' });
        if (props.primaryEmail) {
            gtag4({ event: `Addon_${props.flowType}_Step2_AddonInfoContinueButtonMail`, step: '2', action: 'AddonInfoContinueButtonMail', funnel_name: `Addon_${props.flowType}` });
        }
        else {
            gtag4({ event: `Addon_${props.flowType}_Step2_AddonInfoContinueButtonNoMail`, step: '2', action: 'AddonInfoContinueButtonNoMail', funnel_name: `Addon_${props.flowType}` });
        }

        props.updateService(props.addonId);

        if (serviceData.email.value != props.primaryEmail) {
            props.setNewPrimaryEmail(serviceData.email.value);
        }

        props.createSaleAsync();
    }


    function validatePage() {
        let isValid = true;

        if (props.isDisplayPrimaryEmail) {
            if (!isValidEMail(serviceData.email.value)) {
                serviceData['email'].error = 'נא להזין ערך תקין';
                isValid = false;
            }
            else {
                serviceData['email'].error = '';
            }
        }

        if (props.isDisplayTermsCheckbox) {
            if (!serviceData.isConfirmTerms.value) {
                serviceData.isConfirmTerms.error = 'נא לאשר את תנאי החבילה';
                isValid = false;
            }
        }

        setServiceData({ ...serviceData });
        return isValid;
    }

    function getPriceText(priceItem) {
        const month = ['', 'הראשון', 'השני', 'השלישי', 'הרביעי', 'החמישי', 'השישי', 'השביעי', 'השמיני', 'התשיעי', 'העשירי'];
        if (priceItem.from == 0) {
            return 'חיוב לחודש הראשון';
        }
        return `חיוב חודשי החל מהחודש ${month[priceItem.from]}`;
    }

    function displayPrice(price) {
        if (typeof price === 'number') {
            return parseFloat(price.toFixed(2));
        }
        else {
            const res = parseFloat(parseFloat(price).toFixed(2));
            return res == NaN ? 0 : res;
        }
    };


};

const mapStateToProps = (state) => {
    return {
        flowType: state.addonsBlock.flowType,
        addonId: state.addonsBlock.addonId,
        isDisplayTermsCheckbox: state.addonsBlock.isDisplayTermsCheckbox,
        termsLink: state.addonsBlock.termsLink,
        addon: state.addonsBlock.saleCatalog?.addons?.[0],
        primaryEmail: state.addonsBlock.subscriber.primaryEmail,
        isDisplayPrimaryEmail: state.addonsBlock.isDisplayPrimaryEmail,
    };
};

const mapDispatchToProps = {
    reportDWH,
    updateService,
    setNewPrimaryEmail,
    createSaleAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(ServicePage);
